import React from 'react';
import * as Provincias from '../constantes/Provincias.js';
import { CamposToFechaCorta, CamposToFechaMedia } from '../funciones/FuncionesFecha.js';

export const EsTextoAlfabetico = (texto) => {
  const onlyLettersPattern = /^[\sA-Za-zÑáéíñóú]+$/;
  return texto.match(onlyLettersPattern);
};

export const EsTextoAlfaNumerico = (texto) => {
  const onlyLettersPattern = /^[A-Za-zÀ-ÿ]+(\s*[A-Za-zÀ-ÿ]*)*[A-Za-zÀ-ÿ]+$/;
  return texto.match(onlyLettersPattern);
};

export const TextoFechaLugar = (anio, mes, dia, pais, provincia, localidad) => {
  let texto = '';
  texto = dia ? CamposToFechaCorta(anio, mes, dia) : CamposToFechaMedia(anio, mes, dia);
  const lugar = TextoLugarGeo(pais, provincia, localidad);
  if (lugar !== '') {
    if (texto !== '') {
      texto += ' - ';
    }
    texto += lugar;
  }
  return texto;
};

export const TextoLugarGeo = (pais, provincia, localidad) => {
  let texto = '';
  if (localidad && localidad.id !== null) {
    texto = localidad.nombre;
  }
  if (provincia && provincia.id !== null && provincia.id !== Provincias.CAPITAL_FEDERAL) {
    if (texto !== '') {
      texto += ', ';
    }
    texto += provincia.nombre;
  }
  if (pais) {
    if (texto !== '') {
      texto += ', ';
    }
    texto += pais.nombre;
  }
  return texto;
};

export const TextoMultilinea = (texto) => {
  return <span style={{ whiteSpace: 'pre-line' }}>{texto}</span>;
};

export const TextoOVacio = (texto) => {
  return texto ? texto : '';
};

export const TextoUpperNull = (texto) => {
  return texto ? texto.toString().toUpperCase() : 'null';
};
